import Nullstack from 'nullstack';
export default function IconBarrierBlock({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-barrier-block",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "7",
    width: "16",
    height: "9",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M7 16v4"
  }), "   ", Nullstack.element("path", {
    d: "M7.5 16l9 -9"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 16l6.5 -6.5"
  }), "   ", Nullstack.element("path", {
    d: "M4 13.5l6.5 -6.5"
  }), "   ", Nullstack.element("path", {
    d: "M17 16v4"
  }), "   ", Nullstack.element("path", {
    d: "M5 20h4"
  }), "   ", Nullstack.element("path", {
    d: "M15 20h4"
  }), "   ", Nullstack.element("path", {
    d: "M17 7v-2"
  }), "   ", Nullstack.element("path", {
    d: "M7 7v-2"
  }), " ");
}